






















import { Component, Vue,Prop ,Watch } from 'vue-property-decorator'
import { Monitor } from '@/api/home'
import NoData from '@/components/NoData'

@Component({
  name: 'EnergySaving',
  components:{NoData}
})
export default class EnergySaving extends Vue {
    @Prop({default:''}) code!:string
  private data : any = {executeCount:1,proposalCount:2,rectifyCount:3,punishCount:4}
  public MonitorData(value?:any) {
    const client:any = value? value.regionCode : JSON.parse(localStorage.getItem('client') as any).areaCode
    Monitor(client).then((res :any)=>{
      if(res.status == 0){
        this.data = res.data
      }
      if(!res.data){
        this.data = null
      }
    }).catch(err =>{
    })
  }
    @Watch('code')
    onChangeData(e:any) {
        this.MonitorData(e)
    }
    created() {
        this.MonitorData(this.code)
    }
}
